import styled from 'styled-components';
import tw from 'tailwind.macro';

interface StyledTagProps {
  selected?: boolean;
}

export const Title = styled.h3`
  ${tw`font-semibold mb-4`};
`;

export const Image = styled.figure`
  ${tw`w-full rounded-lg overflow-hidden mt-4 mb-10`};
`;

export const Links = styled.div`
  ${tw`w-full flex justify-between mt-10`};
`;

export const Tags = styled.div`
  ${tw`pt-2 mt-10 flex flex-wrap`}
  gap: 0.5rem;
`;

export const Tag = styled.span<StyledTagProps>`
  ${tw`text-xs text-indigo-900 border border-teal-400 rounded-full px-2 py-1 cursor-pointer`}
  ${({ selected }) => selected && tw`text-indigo-100 bg-teal-400`};
`;
